export const AGENT = 'agent';
export const DEFAULT = 'default';
export const VISITOR = 'visitor';